import { render, staticRenderFns } from "./DonationEmbed.vue?vue&type=template&id=5f58fe4a"
import script from "./DonationEmbed.vue?vue&type=script&lang=js"
export * from "./DonationEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports